<template>
    <div class="grid">
        <loading :active="isLoadingModel" :can-cancel="true" color="#173EA3" :is-full-page="fullPage"></loading>
        <div class="col-12">
            <div class="card">
                <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
                <Toast />
                <div class="col-12">
                <div class="p-fluid formgrid grid" style="margin-top: 2%">
                    <div class="field col-2 md:col-2">
                        <span class="p-float-label">
                            <InputText format="number" v-model="name"> </InputText>
                            <label>Ward Name</label>
                        </span>
                    </div>
                    <div class="field col-2 md:col-2">
                        <span class="p-float-label">
                            <Dropdown id="status" v-model="ward_status" :options="dropdownItems"
                                :value="dropdownItems.value" optionLabel="name" ></Dropdown>
                            <label>Status</label>
                        </span>
                    </div>
                    <div class="field col-2 md:col-2" v-if="user_key && (client_group_ids)">
                        <span class="p-float-label">
                            <Dropdown  id="state" filter v-model="client_id_search"
                                :options="client_id_dropdown" optionLabel="name" :optionValue="code"></Dropdown>
                            <label>Select Client</label>
                        </span>
                    </div>

                    <div class="field col-2 md:col-2">
                        <Button icon="pi pi-search" v-tooltip.bottom="'Search'" @click="search(1)" />

                    </div>
                </div>
            </div>







                <DataTable :loading="loading" ref="dt" :lazy="true" :totalRecords="totalRecords" :paginator="true"
                    :value="products" v-model:selection="selectedProducts" :dataKey="columns[0]" :rows="limit"
                    :filters="filters" @page="onPage($event)"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25, totalRecords]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" responsiveLayout="scroll"
                    style="font-size: 12px" :rowHover="true" showGridlines>
                    <template #empty>
                        <b style="text-align: center">No records found.</b>
                    </template>
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <h5 class="m-0"><b> Ward Master</b></h5>
                            <!-- Total Records:{{totalRecords}} -->
                            <div>
                                <Button icon="pi pi-refresh" @click="search(2)" v-tooltip.bottom="'Refresh'" />&nbsp;
                                <Button icon="pi pi-plus" v-tooltip.bottom="'Add'" @click="openNew" />
                            </div>
                        </div>
                        <div style="text-align: right; font-weight: bold">
                            <span>Total Ward:</span>{{ totalRecords }}
                        </div>
                    </template>
                    <Column header="Sr No" style="min-width: 3rem; text-align: left">
                        <template #body="{ index }">
                            <span v-if="page_no == 1">{{ +index + +1 }}</span>
                            <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
                        </template>
                    </Column>
                    <Column header="status" style="min-width: 5rem ;text-align: center;" :field="columns[9]">
                        <template #body="{ data }">
                            <span v-if="data.status == 'Active' || data.status == 'active'">
                                <badge :value=data.status severity="success"></badge>
                            </span>
                            <span v-else-if="data.status == 'InActive' || data.status == 'In Active'">
                                <badge :value=data.status severity="warning"></badge>
                            </span>
                            <span v-else-if="data.status == 'Delete' || data.status == 'Deleted'">
                                <badge :value=data.status severity="danger"></badge>
                            </span>
                            <span v-else>-</span>
                        </template>
                    </Column>
                    <Column header="Ward Name" :field="columns[1]" style="min-width: 10rem">
                        <template #body="{ data }">
                            {{ data.name }}
                        </template>
                    </Column>
                    <Column header="State" :field="columns[1]" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span v-if="data.state_details && data.state_details.length>0">{{ data.state_details[0].state_id}}-{{data.state_details[0].name }}</span>
                        </template>
                    </Column>
                    <Column header="District" :field="columns[1]" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span v-if="data.district_details && data.district_details.length>0">{{ data.district_details[0].code}} - {{data.district_details[0].name }}</span>
                        </template>
                    </Column>
                    <Column header="Block" :field="columns[1]" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span v-if="data.block_details && data.block_details.length>0">{{ data.block_details[0].code}}-{{data.block_details[0].name }}</span>
                        </template>
                    </Column>
                    <Column header="Village" :field="columns[1]" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span v-if="data.villages_details && data.villages_details.length>0">{{ data.villages_details[0].village_code}}-{{data.villages_details[0].village_name }}</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="min-width:5rem;">
                        <template #body="slotProps">


                            <Button icon="pi pi-pencil" title="Edit Route" v-tooltip.bottom="'Edit'"
                                class="p-button-rounded p-button-help mr-2" @click="editProduct(slotProps.data)" />


                        </template>
                    </Column>
                </DataTable>
                <Dialog header="Ward" v-model:visible="productDialog" :breakpoints="{ '960px': '75vw' }"
                    :style="{ width: '70vw' }" :modal="true">
                    <div class="col-12">
                        <div class="card">
                            <div class="p-fluid formgrid grid">
                                <div class="field col-6 md:col-6" style="margin-top: 1%;">
                                    <span class="p-float-label">
                                        <InputText id="name" type="text" v-model.trim="product.name"
                                            v-tooltip.bottom="'Ward Name'" required="true" autofocus
                                            :class="{ 'p-invalid': submitted && !product.name }" />
                                        <label for="name">Ward Name</label>
                                    </span>
                                </div>
                                <div class="field col-6 md:col-6" style="margin-top: 1%;">
                                    <span class="p-float-label">
                                        <Dropdown id="status" v-model="selectstatus" :options="dropdownItems"
                                            :value="dropdownItems.value" optionLabel="name"
                                            :class="{ 'p-invalid': submitted && !selectstatus }" required="true"></Dropdown>
                                        <label for="status">Status</label>
                                    </span>
                                </div>
                                <div class="field col-6 md:col-6" style="margin-top: 1%;">
                                    <span class="p-float-label">
                                        <InputText id="Description" type="text" v-model.trim="product.Description"
                                            v-tooltip.bottom="'Ward Description'" required="true" autofocus
                                            :class="{ 'p-invalid': submitted && !product.Description }" />
                                        <label for="Description">Ward Description</label>
                                    </span>
                                </div>

                                <div class="field col-6 md:col-6" style="margin-top: 1%;">
                                    <span class="p-float-label">
                                        <Dropdown id="User" filter v-model="state_dropdownItem"
                                            :options="state_dropdownItems" optionLabel="name" @change="getDistrictData">
                                        </Dropdown>
                                        <label for="State d">State</label>
                                    </span>
                                </div>
                                <div class="field col-6 md:col-6" style="margin-top: 1%;">
                                    <span class="p-float-label">
                                        <Dropdown id="User" filter v-model="district_dropdownItem"
                                            :options="district_dropdownItems" optionLabel="name" @change="getBlockData">
                                        </Dropdown>
                                        <label for="District">District</label>
                                    </span>
                                </div>
                                <div class="field col-6 md:col-6" style="margin-top: 1%;">
                                    <span class="p-float-label">
                                        <Dropdown id="Block" filter v-model="block_dropdownItem"
                                            :options="block_dropdownItems" optionLabel="name" :loading="set_loading">
                                        </Dropdown>
                                        <label for="Block">Block</label>
                                    </span>
                                </div>
                                <div class="field col-6 md:col-6" style="margin-top: 1%;">
                                    <span class="p-float-label">
                                        <Dropdown v-model="village_dropdownItem" :options="village_dropdownItems"
                                            optionLabel="name" filter display="chip" @filter="get_village">

                                        </Dropdown>
                                        <label for="Village">Village</label>
                                    </span>
                                </div>


                            </div>
                        </div>
                    </div>
                    <template #footer>
                        <Button v-if="product._id" label="UPDATE" icon="pi pi-check" v-tooltip.bottom="'UPDATE'"
                            class="p-button-success mr-1 mb-1" @click="adduser" />
                        <Button v-else label="ADD" icon="pi pi-check" v-tooltip.bottom="'ADD'"
                            class="p-button-success mr-1 mb-1" @click="adduser" />

                    </template>


                </Dialog>
                <!-- 
    -----------------------------------------------------------------------------------------------------------   -->
                <Dialog v-model:visible="deleteProductDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
                    <div class="flex align-items-center justify-content-center">
                        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                        <span v-if="product">Are you sure you want to delete <b>{{ product.service_name }}</b>?</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false" />
                        <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteservice" />
                    </template>
                </Dialog>
                <Dialog v-model:visible="deleteProductsDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
                    <div class="flex align-items-center justify-content-center">
                        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                        <span v-if="product">Are you sure you want to delete the selected products?</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductsDialog = false" />
                        <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedProducts" />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import JsonExcel from "vue-json-excel";
import BreadcrumbService from "../service/BreadcrumbService";
//import FormNewsMaster from "@/components/FormNewsMaster";

// import axios from "axios";
import apis from "@/apis";
import axios from "axios";
import { log } from "util";
export default {
    data() {
        return {
            ward_status: null,
            name: '',

            state_dropdownItems: [],
            state_dropdownItem: null,
            district_dropdownItems: [],
            district_dropdownItem: null,
            block_dropdownItems: [],
            block_dropdownItem: null,
            village_dropdownItems: [],
            village_dropdownItem: null,

            client_id_dropdown: [],
            client_id_search: '',
            user_key: "",
            client_group_ids: '',
            place_details: "",
            end_place_details: "",
            searchme: "",

            page_no: 1,
            isLoading: false,
            isLoadingModel: false,
            loading: false,
            fullPage: true,
            file_attachment: "",
            icon_dropdown: [],
            service_name: "",
            dropdownItems: [
                { name: "Active", value: "Active" },
                { name: "InActive", value: "InActive" },
                { name: "Deleted", value: "Deleted" },
            ],
            parent_dropdownItems: [],
            selectstatus: { name: "", value: "" },
            parent_selectstatus: { name: "", value: "" },
            pick_icon: { name: "", value: "" },
            products: null,
            productDialog: false,
            deleteProductDialog: false,
            deleteProductsDialog: false,
            lazyParams: {},
            product: {},
            selectedProducts: null,
            filters: {},
            offset: 1,
            // selectstatus2: { name: "Motivational", value: "Motivational" },
            limit: 10,
            columns: [],
            head: [
                "Data Usages",
                "Network Connectivity",
                "Students",
                "Teachers",
                "Student Registration",
                "News Master",
                "Government Panel",
                "Feedback Master",
                "User Queries",
                "Schemes Master",
                "Notice Master",
                "Subject Master",
                "Teacher Schedule Master",
                "Teacher Schedule DE Master",
                "Query Types Master",
                "Sub Query Types Master",
                "Admin Users",
                "Application Roles",
                "Departments",
                "Cast Master",
                "Year Master",
                "District Master",
                "Student Attendance",
                "Student Document",
                "Teachers",
                "Radical ids",
                "Subject Topics",
                "Query Comments",
                "Student Submit Answers",
                "Mock Tests",
                "Mock Test Papers",
                "Mock Test Results",
                "Video",
                "Syllabus",
                "Course",
            ],
            pageno: 1,
            submitted: false,
            icons: null,
            totalRecords: 0,
            id: "",
            statuses: [
                { label: "INSTOCK", value: "instock" },
                { label: "LOWSTOCK", value: "lowstock" },
                { label: "OUTOFSTOCK", value: "outofstock" },
            ],
            BreadcrumbService: null,
            breadcrumbHome: {},
            breadcrumbItems: [],
        };
    },
    productService: null,
    async created() {
        this.productService = new ProductService();
        this.initFilters();
        this.BreadcrumbService = new BreadcrumbService();
        let Breadcrum_data = this.BreadcrumbService.getBreadcrum(
            "Ward Master",
            "/ward_master"
        );
        this.breadcrumbHome = Breadcrum_data.home;
        this.breadcrumbItems = Breadcrum_data.items;
        this.user_key = localStorage.getItem("user_key");
        this.client_group_ids = localStorage.getItem('client_group_ids');
        this.get_client_list();
        this.getstateData();
        //this.getDistrictData();
        this.getBlockData();
    },
    async mounted() {
        this.id = this.$route.params.id;
        this.lazyParams = {
            first: 0,
            rows: this.limit,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        if (this.totalRecords == 0) {
            await this.get_count();
        }
        await this.get_list();
        //alert(this.id);
    },
    watch: {
        async $route() {
            this.products = [];
            this.columns = [];
            this.totalRecords = 0;
            this.id = this.$route.params.id;
            if (this.id) {
                await this.get_count();
                this.get_list();
            }
        },
    },
    methods: {
        adduser() {
            this.submitted = true;
            if (this.product._id) {


                var data = {
                    "_id": this.product._id,
                    "name": this.product.name,
                    "status": this.selectstatus.value,
                    "Description": this.product.Description,
                    "state_id": this.state_dropdownItem.value,
                    "district_id": this.district_dropdownItem.value,
                    "block_id": this.block_dropdownItem.value,
                    "village_id": this.village_dropdownItem.value,
                    "client_id": this.client_id_search.value ? this.client_id_search.value : localStorage.getItem("client_id"),
                    "created_at": "",
                    "updated_at": "",
                    "created_by": localStorage.getItem("id"),
                    "updated_by": "",

                };

                this.isLoadingModel = true;
                var promise = apis.edit_WardMaster(data);
                promise
                    .then((responseapi) => {
                        this.$swal(responseapi.data.message);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.get_list();
                        this.get_count();
                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.productDialog = false;

                        this.$swal.fire(error.response.data);
                        this.get_list();
                        this.get_count();
                    });
            }
            //add-----------------------------------------------------------------------------------------------------------------
            else {
                var data1 = {
                    "name": this.product.name,
                    "status": this.selectstatus.value,
                    "Description": this.product.Description,
                    "state_id": this.state_dropdownItem.value,
                    "district_id": this.district_dropdownItem.value,
                    "block_id": this.block_dropdownItem.value,
                    "village_id": this.village_dropdownItem.value,
                    "client_id": this.client_id_search.value ? this.client_id_search.value : localStorage.getItem("client_id"),
                    "created_at": "",
                    "updated_at": "",
                    "created_by": localStorage.getItem("id"),
                    "updated_by": "",
                };
                this.isLoadingModel = true;
                var promises = apis.Add_WardMaster(data1);
                promises
                    .then((response) => {
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal(response.data.message);
                        this.get_list();
                        this.get_count();
                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.productDialog = false;

                        this.$swal.fire(error.response.data);
                        this.get_list();
                        this.get_count();
                    });
            }
        },











        get_client_list() {
            const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')) : [];

            var data = { count: false };
            var promise = apis.getclientist(data);
            promise.then((response) => {

                var temp_data = [];

                for (let x = 0; x < response.data.data.length; x++) {
                    const clientData = response.data.data[x];

                    if (clientData.client_name && (client_group_ids.length === 0 || client_group_ids.includes(clientData._id))) {
                        temp_data.push({ name: clientData.client_name, value: clientData._id });
                    }
                }

                this.client_id_dropdown = temp_data;
            });
        },
        async get_village(search) {
            var district_code = [];
            var block_code = [];
            if (this.district_dropdownItem) {

                district_code.push(this.district_dropdownItem.value);

            }
            if (this.block_dropdownItem) {

                block_code.push(this.block_dropdownItem.value);

            }

            var data = {
                "count": false,
                "page_no": 1,
                "limit": 10,
                "search_name": search.value,
                district_code: district_code,
                block_code: block_code,
            };
            var promise = apis.getVillageData(data);
            promise.then((response) => {
                this.village_dropdownItems = [];
                var temp = response.data.data;
                for (let a = 0; a < temp.length; a++) {
                    this.village_dropdownItems.push({ name: temp[a].village_name, value: temp[a].village_code });



                }
            });




        },
        async getBlockData() {

            this.block_dropdownItem = null;
            this.block_dropdownItems = [];
            var district_code = [];
            if (this.district_dropdownItem) {

                district_code.push(this.district_dropdownItem.value);

            }
            this.set_loading = true;
            var data = {
                district_code: district_code,
                count: false,
            };
            var promise = apis.getBlockData(data);
            promise.then((response) => {
                this.set_loading = false;
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].name,
                            value: response.data.data[x].code,
                        });

                    }

                    this.block_dropdownItems = temp_data;
                }
            });
        },
        async getstateData() {
            this.state_dropdownItem = null;
            const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')) : [];

            var client_id = this.client_id_search.code
                ? this.client_id_search.code
                : localStorage.getItem("client_id");
            this.loading = true;
            var data = {
                client_id: client_id,
                "client_group_ids": client_group_ids,
                count: false,
            };
            var promise = apis.stateMaster(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].name,
                            value: response.data.data[x].state_id,
                        });

                    }

                    this.state_dropdownItems = temp_data;

                }
            });
        },
        async getDistrictData() {
            this.district_dropdownItem = null;
            const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')) : [];

            var client_id = this.client_id_search.code
                ? this.client_id_search.code
                : localStorage.getItem("client_id");
            this.loading = true;
            var data = {
                client_id: client_id,
                "client_group_ids": client_group_ids,
                count: false,
            };
            var promise = apis.getStateData(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].name,
                            value: response.data.data[x].code,
                        });

                    }

                    this.district_dropdownItems = temp_data;

                }
            });
        },

        dateFormatDMY(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == "NaN-NaN-NaN") {
                    return postdate;
                } else {
                    let date = ("0" + inputDate.getDate()).slice(-2);
                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == "aN") {
                        return postdate;
                    } else {
                        return date + "/" + month + "/" + year;
                    }
                }
            } else {
                return "";
            }
        },
        async search(count) {
            if (count == 2) {
                this.client_id_search = '';
                this.name = '';
                this.ward_status = null;
            }
            await this.get_list();
            await this.get_count();
        },
        async viewProduct(product) {
            // console.log(JSON.stringify(product));
            await localStorage.setItem("saveservicedata", JSON.stringify(product));
            this.$router.push({ name: "serviceProfile" });
        },
        async editProduct(product) {
            this.file_attachment = "";
            this.product = { ...product };
            this.productDialog = true;
            //this.product.state='Maharashtra';
            this.selectstatus = { name: "", value: "" };
            this.selectstatus.value = this.product.status;
            this.selectstatus.name = this.product.status;

            this.village_dropdownItem = null;
            this.block_dropdownItem = null;
            this.district_dropdownItem = null;
            this.state_dropdownItem = null;
            this.getstateData();
            this.getDistrictData();
            this.getBlockData();
            if (this.product.state_details && this.product.state_details.length > 0) {
                this.state_dropdownItem = { name: this.product.state_details[0].name, value: this.product.state_details[0].state_id };
            }
            if (this.product.district_details && this.product.district_details.length > 0) {
                this.district_dropdownItem = { name: this.product.district_details[0].name, value: this.product.district_details[0].code };
            }
            if (this.product.block_details && this.product.block_details.length > 0) {
                this.block_dropdownItem = { name: this.product.block_details[0].name, value: this.product.block_details[0].code }
            }
            if (this.product.villages_details && this.product.villages_details.length > 0) {
                this.village_dropdownItem = { name: this.product.villages_details[0].village_name, value: this.product.villages_details[0].village_code };
                var search = { value: this.product.villages_details[0].village_name };
                await this.get_village(search);
            }

        },
        isNumber(evt) {
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            }
        },
        async onPage(event) {
            this.lazyParams = event;
            this.page_no = event.page + 1;
            this.limit = event.rows;
            if (this.totalRecords > 0) {
                this.get_list();
            }
        },
        get_count: function () {
            var client_group_ids = [];
            if (localStorage.getItem('client_group_ids')) {
                client_group_ids = JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
            if (this.client_id_search && this.client_id_search.length > 0) {
                client_group_ids = []
                for (let x = 0; x < this.client_id_search.length; x++) {
                    client_group_ids.push(this.client_id_search[x].value);

                }
            }

            var data = {
                count: true,
                name: this.name,
                status: this.ward_status == null ? '' : this.ward_status.value,
                client_id: this.client_id_search.value ? this.client_id_search.value : localStorage.getItem("client_id"),
                client_group_ids: client_group_ids

            };
            this.loading = true;
            var promise = apis.WardMaster_list(data);
            promise.then((response) => {
                this.loading = false;
                //   console.log(response);
                this.totalRecords = response.data.data;
                //alert(this.totalRecords);
            });
            // console.log(data);
        },
        get_list: function () {
            var client_group_ids = [];
            if (localStorage.getItem('client_group_ids')) {
                client_group_ids = JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
            if (this.client_id_search && this.client_id_search.length > 0) {
                client_group_ids = []
                for (let x = 0; x < this.client_id_search.length; x++) {
                    client_group_ids.push(this.client_id_search[x].value);

                }
            }

            var data = {
                limit: this.limit,
                page_no: this.page_no,
                count: false,
                name: this.name,
                status: this.ward_status == null ? '' : this.ward_status.value,
                client_id: this.client_id_search.value ? this.client_id_search.value : localStorage.getItem("client_id"),
                client_group_ids: client_group_ids
            };
            this.loading = true;
            var promise = apis.WardMaster_list(data, this.id);
            promise.then((response) => {
                this.loading = false;
                console.log(response);
                this.products = response.data.data;
                console.log(this.products[0]);
                if (this.columns.length == 0) {
                    if (this.products.length > 0) {
                        this.columns = Object.keys(this.products[0]);
                    }
                }
            });
            console.log(data);
        },
        formatCurrency(value) {
            if (value)
                return value.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                });
            return;
        },
        openNew() {
            this.product = {};
            this.submitted = false;
            this.productDialog = true;
            this.selectstatus = null;
            this.product.state = 'Maharashtra';
            this.village_dropdownItem = null;
            this.block_dropdownItem = null;
            this.district_dropdownItem = null;
            this.state_dropdownItem = null;
        },
        hideDialog() {
            this.productDialog = false;
            this.submitted = false;
        },
        confirmDeleteProduct(product) {
            this.product = product;
            this.deleteProductDialog = true;
        },
        deleteProduct() {
            this.products = this.products.filter((val) => val.id !== this.product.id);
            this.deleteProductDialog = false;
            this.product = {};
            this.$toast.add({
                severity: "success",
                summary: "Successful",
                detail: "Product Deleted",
                life: 3000,
            });
        },
        deleteservice() {
            if (this.product._id) {
                var data = {
                    _id: this.product._id,
                    user_id: localStorage.getItem("id"),
                };
                this.isLoadingModel = true;
                var promise = apis.deleteservicedata(data);
                promise.then((responseapi) => {
                    this.isLoadingModel = false;
                    if (responseapi.data.status == true) {
                        // this.hideDialog1();
                        this.deleteProductDialog = false;
                        this.$swal(responseapi.data.message);
                        this.get_list();
                        this.get_count();
                    } else {
                        this.$swal("error to Delete Role");
                    }
                });
            }
        },
        findIndexById(id) {
            let index = -1;
            for (let i = 0; i < this.products.length; i++) {
                if (this.products[i].id === id) {
                    index = i;
                    break;
                }
            }
            return index;
        },
        createId() {
            let id = "";
            var chars =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < 5; i++) {
                id += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return id;
        },
        async exportCSV() {
            this.limit = this.totalRecords;
            this.get_list();
            await this.$refs.dt.exportCSV();
        },
        confirmDeleteSelected() {
            this.deleteProductsDialog = true;
        },
        deleteSelectedProducts() {
            this.products = this.products.filter(
                (val) => !this.selectedProducts.includes(val)
            );
            this.deleteProductsDialog = false;
            this.selectedProducts = null;
            this.$toast.add({
                severity: "success",
                summary: "Successful",
                detail: "Products Deleted",
                life: 3000,
            });
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
    },
    components: { downloadExcel: JsonExcel },
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";
@import "../assets/demo/documentation.scss";

.icons-list {
    i {
        color: var(--text-color-secondary);
    }
}
</style>
  